module.exports = __webpack_public_path__ + "static/media/logo.639cdf15.svg";